import VerticalTabs, { VerticalTabsProps } from '.';
import React from 'react';

// This object should contain a mock value for each required prop of this component
export const requiredProps: VerticalTabsProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as VerticalTabsProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      children: [
        // @ts-ignore
        <VerticalTabs key="1">
          <VerticalTabs.TabsGroup title="Current Benefits">
            {/* @ts-ignore */}
            <VerticalTabs.TabItem id={0}>
              Experts Dashboard
            </VerticalTabs.TabItem>
            {/* @ts-ignore */}
            <VerticalTabs.TabItem id={1}>Product Betas</VerticalTabs.TabItem>
            {/* @ts-ignore */}
            <VerticalTabs.TabItem id={2}>
              Wix Arena Exposure
            </VerticalTabs.TabItem>
          </VerticalTabs.TabsGroup>
          <VerticalTabs.TabsGroup title="Next Level Benefits">
            {/* @ts-ignore */}
            <VerticalTabs.TabItem id={3}>Loyalty Program</VerticalTabs.TabItem>
            {/* @ts-ignore */}
            <VerticalTabs.TabItem id={4}>
              20% Revenue Share
            </VerticalTabs.TabItem>
            {/* @ts-ignore */}
            <VerticalTabs.TabItem id={5}>
              Dedicated Account Manager
            </VerticalTabs.TabItem>
          </VerticalTabs.TabsGroup>
        </VerticalTabs>,
      ],
    } as VerticalTabsProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
